<template>
  <div style="width: 1200px; margin: 0 auto; background-color: #f2f6fc">
    <Title :title="{ name: '我的申请', path: '/my/apply/list' }"></Title>
    <div style="margin: 10px auto">
      <el-card class="box-card">
        <el-row :gutter="20" style="margin-left: 10px">
          <el-col :span="6">
            <el-select v-model="qparam.applyType">
              <el-option
                v-for="item in flowData"
                :key="item.flowId"
                :label="item.flowName"
                :value="item.flowId"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-select
              style="margin-right: 15px"
              v-model="qparam.examineResult"
              placeholder="请选择审批状态"
              clearable
            >
              <el-option label="全部" value="0"> </el-option>
              <el-option key="1" label="审核中" value="1"> </el-option>
              <el-option key="3" label="申请被拒" value="3"> </el-option>
              <el-option key="2" label="申请通过" value="2"> </el-option>
            </el-select>
          </el-col>
          <el-col :span="8">
            <el-date-picker
                style=""
                v-model="applyTime"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-left: 10px; margin-top: 10px">
          <!--项目负责人-->
          <el-col :span="5">
            <el-select v-model="qparam.projectManager" placeholder="请选择项目负责人" filterable style="width: 100%"  v-if="showProjectManager">
              <el-option
                  v-for="item in sysUserList"
                  :key="item.userId"
                  :label='item.realName'
                  :value="item.userId"
              ></el-option>
            </el-select>
          </el-col>
          <!--项目ID-->
          <el-col :span="10">
            <el-select style="margin-right: 15px; width: 50%" v-model="qparam.projectId"
                       placeholder="请选择项目" filterable @change="getProjetInfo" v-if="showProject">
              <el-option
                  v-for="item in projectList"
                  :key="item.projectId"
                  :label="item.projectName"
                  :value="item.projectId">
                <span style="float: left">{{ item.projectName }}&nbsp&nbsp{{item.projectIden}}</span>&nbsp&nbsp
                <el-tag v-if="item.projectState === 6" type="info" size="mini">S: 已终止</el-tag>
                <span style="float: left">&nbsp&nbspM: {{ item.managerName }}</span>
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="5">
            <el-button
              icon="el-icon-refresh-left"
              type="primary"
              @click="resetQparam"
              >重置</el-button
            >
            <el-button
              icon="el-icon-search"
              type="primary"
              @click="initTableData"
              >查询</el-button
            >
          </el-col>
        </el-row>
      </el-card>
    </div>

    <div style="margin: 10px auto">
      <el-card class="box-card">
        <el-badge :value="refuseCount" class="item">
          <el-button size="small" @click="queryRefuse">审批被拒</el-button>
        </el-badge>
        <el-badge :value="notApprovedCount" class="item">
          <el-button size="small" @click="querynotApproved">审核中</el-button>
        </el-badge>
        <el-badge class="item" :value="cancelCount">
          <el-button size="small" @click="querynotCancelApply"
            >已撤回</el-button
          >
        </el-badge>
      </el-card>
    </div>

    <div style="margin: 10px auto">
      <el-card class="box-card" style="min-height: 650px">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column label="申请类型">
            <template slot-scope="scope">
              <div v-for="(row, index) in flowData" :key="index">
                <el-tag type="success" v-if="row.flowId === scope.row.flowId">{{
                  row.flowName
                }}</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="当前审核人">
            <template slot-scope="scope">
              <span v-if="scope.row.examineResult === 1">
                {{ scope.row.auditName }}
              </span>
              <el-tag v-else type="info">已结束</el-tag>
            </template>
          </el-table-column>

          <el-table-column label="审批状态">
            <template slot-scope="scope">
              <el-tag
                type=""
                v-if="scope.row.examineResult == 1 && scope.row.applyState == 1"
              >
                审批中
              </el-tag>
              <el-tag type="danger" v-if="scope.row.examineResult == 3">
                审批不通过
              </el-tag>
              <el-tag
                type="success"
                v-if="scope.row.examineResult == 2 && scope.row.applyState == 1"
              >
                审批通过
              </el-tag>
              <el-tag
                type="info"
                v-if="
                  scope.row.applyState == 2 && scope.row.examineResult !== 3
                "
              >
                已撤回
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="applyTime" label="申请时间"> </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.applyState == 1 || scope.row.examineResult == 3"
                size="mini"
                type="danger"
                @click="handleDetail(scope.$index, scope.row)"
                >查看申请
              </el-button>
              <el-button
                v-if="scope.row.applyState == 2"
                size="mini"
                type="success"
                @click="reapply(scope.$index, scope.row)"
                >重新申请
              </el-button>
<!--              <el-popconfirm-->
<!--                title="确定撤回该申请？"-->
<!--                @confirm="cancelApply(scope.row)"-->
<!--              >-->
<!--                <el-button-->
<!--                  v-if="-->
<!--                    scope.row.applyState == 1 && scope.row.examineResult == 1-->
<!--                  "-->
<!--                  style="margin-left: 10px"-->
<!--                  slot="reference"-->
<!--                  size="mini"-->
<!--                  type="warning"-->
<!--                >-->
<!--                  撤回-->
<!--                </el-button>-->
<!--              </el-popconfirm>-->
              <el-button v-if="scope.row.applyState == 1 && scope.row.examineResult == 1"
                      size="mini"
                      type="warning"
                      @click="cancelApply(scope.row)">撤回
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 详情弹框 -->
        <el-dialog
            custom-class="no-padding-dialog no-margin-dialog"
            :title="detailDialogTitle"
            :visible.sync="showDetailDialog"
            width="100%"
            :before-close="handleDialogClose">
          <!-- 详情组件 -->
          <component :is="currentDetailComponent" :query="selectedQuery" />
        </el-dialog>
        <div style="margin: 40px auto; width: 30%">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="currentPageChangeEvent"
            :current-page="qparam.current"
            :page-sizes="[5, 10, 20, 50]"
            :page-size="qparam.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalElements"
          >
          </el-pagination>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import {
  requestApplyList,
  requestCancelApply,
  requestApplyCount, requestUserGet, requestAllProject, requestProjectDetail,
} from "../../api";
import Title from "../Title";
import { mapState } from "vuex";
import ProjectDetail from "@/components/item/project/ProjectDetail.vue";
import CostReportDetail from "@/components/item/costreport/CostReportDetail.vue";
import OutReportDetail from "@/components/item/outreport/OutReportDetail.vue";
import LeaveDetail from "@/components/item/leave/LeaveDetail.vue";
import PaymentDetail from "@/components/item/payment/PaymentDetail.vue";
import ReimburseDetail from "@/components/item/reimburse/ReimburseDetail.vue";
import SealDetail from "@/components/item/seal/SealDetail.vue";
import EnforceDetail from "@/components/item/enforce/EnforceDetail.vue";
import ContractDetail from "@/components/item/contract/ContractDetail.vue";
import CoworkingDetail from "@/components/item/coworking/CoworkingDetail.vue";
import ProjectModifyDetail from "@/components/item/project/ProjectModifyDetail.vue";
import PurchaseDetail from "@/components/item/purchase/PurchaseDetail.vue";
import AllegeDetail from "@/components/item/allege/AllegeDetail.vue";
import InvoiceDetail from "@/components/item/invoice/InvoiceDetail.vue";
import DeliveryDetail from "@/components/item/delivery/DeliveryDetail.vue";
import PettyCashDetail from "@/components/item/pettyCash/PettyCashDetail.vue";
import {uuid} from "@/util";
export default {
  name: "MyApplyList",
  components: { Title,
    ProjectDetail, CostReportDetail, OutReportDetail, LeaveDetail,
    PaymentDetail, ReimburseDetail, SealDetail,
    EnforceDetail, ContractDetail, CoworkingDetail, ProjectModifyDetail,
    PurchaseDetail, AllegeDetail, InvoiceDetail, DeliveryDetail, PettyCashDetail },
  data() {
    return {
      projectList: [],
      sysUserList: [],
      uuid: "",
      refuseCount: "",
      notApprovedCount: "",
      cancelCount: "",
      tableData: [],
      totalElements: 0,
      qparam: {
        current: 1,
        size: 10,
        examineResult: "",
        applyType: "",
        projectId: null,
        projectManager: null,
        startTime: "",
        endTime: "",
      },
      applyTime: [],
      apply: {},
      showDetailDialog: false, // 控制弹框显示
      selectedQuery: {},       // 存储当前选中行的参数
      dataList: [],            // 列表数据
      applyType: "",           // 申请类型
      detailDialogTitle: ""    // dialog标题
    };
  },
  computed: {
    ...mapState(["flowData"]),
    // 动态选择详情组件
    currentDetailComponent() {
      switch (this.applyType) {
        case 1:
          this.detailDialogTitle = "立项申请详情";
          return "ProjectDetail";
        case 2:
          this.detailDialogTitle = "招待费申请详情";
          return "CostReportDetail";
        case 3:
          this.detailDialogTitle = "外出申请详情";
          return "OutReportDetail";
        case 4:
          this.detailDialogTitle = "请假申请详情";
          return "LeaveDetail";
        case 5:
          this.detailDialogTitle = "付款申请详情";
          return "PaymentDetail";
        case 6:
          this.detailDialogTitle = "费用报销申请详情";
          return "ReimburseDetail";
        case 7:
          this.detailDialogTitle = "用章申请详情";
          return "SealDetail";
        case 9:
          this.detailDialogTitle = "实施文件归档详情"
          return "EnforceDetail";
        case 10:
          this.detailDialogTitle = "合同文件归档详情";
          return "ContractDetail";
        case 11:
          this.detailDialogTitle = "协同办公申请详情";
          return "CoworkingDetail";
        case 12:
          this.detailDialogTitle = "项目变更申请详情";
          return "ProjectModifyDetail";
        case 13:
          this.detailDialogTitle = "采购申请详情";
          return "PurchaseDetail";
        case 14:
          this.detailDialogTitle = "考勤申诉详情";
          return "AllegeDetail";
        case 15:
          this.detailDialogTitle = "发票开具申请详情";
          return "InvoiceDetail";
        case 16:
          this.detailDialogTitle = "项目交付申请详情";
          return "DeliveryDetail";
        case 17:
          this.detailDialogTitle = "备用金申请详情"
          return "PettyCashDetail"
        default:
          this.detailDialogTitle = "";
          return "";
      }
    },
    showProject() {
      return [1, 7, 10, 12, 15, 16].includes(Number(this.qparam.applyType));
    },
    showProjectManager() {
      return [1, 12].includes(Number(this.qparam.applyType));
    }
  },
  watch: {
    'qparam.applyType'(val) {
      const type = Number(val);
      if (![1, 7, 10, 12, 15, 16].includes(type)) {
        this.qparam.projectId = null;
      }
      if (![1, 12].includes(type)) {
        this.qparam.projectManager = null;
      }
    }
  },
  methods: {
    async loadSysUserData() {
      let res = await requestUserGet();
      if (res.code === 200) {
        this.sysUserList = res.object;
      } else {
        this.$message.error("获取人员列表失败")
      }
    },
    getAllProject() {
      requestAllProject({}).then(res => {
        if (res.code === 200) {
          if (res.object) {
            this.projectList = res.object
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    getProjetInfo(id) {
      this.disabled = false
      requestProjectDetail({projectId: id}).then(res => {
        if (res.code === 200) {
          if (res.object) {
            let detail = res.object.detail
            this.ruleForm.projectAmountExpect = detail.projectAmountExpect.toString()
            this.ruleForm.projectName = detail.projectName
            this.ruleForm.projectState = detail.projectState.toString()
            this.ruleForm.projectManager = detail.projectManager
            let surveys = res.object.surveys
            this.ruleForm.surveyBody = surveys[surveys.length - 1].surveyBody
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    handleSizeChange(size) {
      this.qparam.current = 1;
      this.qparam.size = size;
      this.initTableData();
    },
    resetQparam() {
      this.applyTime = []
      this.qparam.applyType = "";
      this.qparam.examineResult = "";
      this.qparam.projectId = "";
      this.qparam.projectManager = "";
      this.qparam.startTime = ""
      this.qparam.endTime = "";
      this.initTableData();
    },
    handleDetail(index, row) {
      this.selectedQuery = {
        applyId: row.applyId,
        applyServiceId: row.applyServiceId,
        applyType: row.applyType,
      }
      this.applyType = row.applyType;
      this.showDetailDialog = true;
      this.uuid = uuid();
    },
    handleDialogClose() {
      // 关闭弹框前可以进行一些清理操作
      this.selectedQuery = {};
      this.applyType = "";
      this.showDetailDialog = false;
    },
    currentPageChangeEvent(currentPage) {
      this.qparam.current = currentPage;
      this.initTableData();
    },
    async queryRefuse() {
      const res = await requestApplyList({ examineResult: 3 });
      if (res.code == 200) {
        this.totalElements = res.total;
        this.tableData = res.rows;
      } else {
        this.$message.error(res.msg);
      }
      this.getApplyCount();
    },
    async querynotApproved() {
      const res = await requestApplyList({ examineResult: 1, applyState: 1 });
      if (res.code == 200) {
        this.totalElements = res.total;
        this.tableData = res.rows;
      } else {
        this.$message.error(res.msg);
      }
      this.getApplyCount();
    },
    async querynotCancelApply() {
      const res = await requestApplyList({ examineResult: 1, applyState: 2 });
      if (res.code == 200) {
        this.totalElements = res.total;
        this.tableData = res.rows;
      } else {
        this.$message.error(res.msg);
      }
      this.getApplyCount();
    },
    async initTableData() {
      this.qparam.startTime = this.applyTime[0]
      this.qparam.endTime = this.applyTime[1]
      const res = await requestApplyList(this.qparam);
      if (res.code == 200) {
        this.totalElements = res.total;
        this.tableData = res.rows;
      } else {
        this.$message.error(res.msg);
      }
      this.getApplyCount();
    },
    async cancelApply(row) {
      this.$confirm('确认要撤回该申请吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        console.log('进入撤销方法!')
        const applyId = row.applyId;
        const res = await requestCancelApply({ applyId: applyId });
        if (res.code == 200) {
          this.$message.success(res.msg);
          await this.initTableData();
        } else {
          this.$message.error(res.msg);
        }
        this.getApplyCount();
      })
    },
    reapply(index, row) {
      let path = row.path.split("/");
      path = `/${path[1]}/${path[2]}`;
      this.$router.push({
        path: path,
        query: {
          applyId: row.applyId,
          applyServiceId: row.applyServiceId,
          applyType: row.applyType,
        },
      });
    },
    getApplyCount() {
      requestApplyCount().then((res) => {
        if (res.code == 200) {
          this.cancelCount = res.object.cancelCount;
          this.notApprovedCount = res.object.notApprovedCount;
          this.refuseCount = res.object.refuseCount;
          this.handZero();
        }
      });
    },
    handZero() {
      if (this.cancelCount == 0) {
        this.cancelCount = "";
      }
      if (this.notApprovedCount == 0) {
        this.notApprovedCount = "";
      }
      if (this.refuseCount == 0) {
        this.refuseCount = "";
      }
    },
  },
  created() {
    this.getAllProject()
    this.loadSysUserData()
    this.initTableData();
    this.getApplyCount();
  },
};
</script>

<style scoped>
.item {
  margin-top: 10px;
  margin-right: 40px;
}
::v-deep .no-padding-dialog .el-dialog__body {
  padding: 0;
}
::v-deep .no-margin-dialog {
  margin-top: 0 !important;
}
</style>
